import { TimelineCpoeMaterialResponse } from '../electronic-service-timeline/electronic-service-timeline-response';

export interface ParamsProps {
  amountAdministered?: number;
  cdIntervalId?: string;
  cdMaterialId?: string;
  chemotherapy?: boolean;
  chemotherapyStatus?: string;
  cpoeMaterial?: TimelineCpoeMaterialResponse;
  cpoeSequence?: number,
  dripQuantity?: number
  dsMaterialId?: string;
  encounterId?: string;
  hourSequence?: string;
  id?: string;
  ieAcmId?: string;
  ieSpecialTimeId?: string;
  ieStatus?: string;
  ieTypeItem?: string;
  ieViaApplicationDescription?: string;
  ieViaApplicationId?: string;
  infusionSpeed?: string;
  internalProcedureSequence?: number;
  isFirstChecked?: string;
  isMedication?: string;
  itemStatus?: string;
  modalIsVisible?: string;
  nrCurrentStageId?: string;
  nrGroupingId?: string;
  nrPrescriptionId?: string;
  nrPrescriptionsId?: string;
  nrSequenceId?: string;
  observationDescription?: string,
  partialVolume?: number;
  patientId?: string;
  pdoPrn?: boolean,
  pendingHours?: number;
  qtDoseId?: string;
  stageVolume?: number;
  startId?: string;
  totalVolume?: number
  unitMeasureDoseDescription?: string;
  uom?: string;
  prescriptionValidityDate?: string;
}

interface CurrentSpeedInfusionProps {
  currentSpeedInfusion?: number;
}

export class MedicineAndSolutionsParams {
  static params: ParamsProps;
  static speedParam: CurrentSpeedInfusionProps;
}
